import { Skeleton } from '@/components/shadcn/skeleton'
import { FormContentV2 } from './FormContentV2'
import { BaseFieldProps, InferFormValues, JsonFormSchemaV2 } from './types'
import { useGetForm } from './useGetForm'
import { useTileFilterSelections } from '../../../hooks/useTileFilterSelections'

export const FormComponent = <TSchema extends JsonFormSchemaV2>(props: {
  id: string
  variant?: BaseFieldProps['variant']
  resetDefaults?: InferFormValues<TSchema>
  className?: string
}) => {
  const { id, ...rest } = props
  const { data } = useGetForm(id, [])
  const { tileFilterSelections, filterChangeHandler } = useTileFilterSelections(data.filters)

  // Refetch with filters applied
  const dataWithFilters = useGetForm(id, tileFilterSelections).data

  const submitHandler = (formData: InferFormValues<typeof dataWithFilters.uiSchema>) => {
    console.log('FormComponent submitHandler data', formData)
  }

  return (
    <FormContentV2
      schema={dataWithFilters.uiSchema}
      submitHandler={submitHandler}
      filterChangeHandler={filterChangeHandler}
      tileFilterSchema={dataWithFilters.filters}
      {...rest}
    />
  )
}
